import axios from "axios";

const instance = axios.create({
  baseURL: "https://api.dev.breathe4school.in/api/v1"
  //baseURL: "https://api.dev.breathe4school.in/api/v1",
  // baseURL: "http://localhost:3002/api/v1",
});


//ALLOW INTERCEPTORS TO ADD AUTHORIZATION JWT TOKEN SAVED IN STORAGE
instance.interceptors.request.use(config => {
  // Add the Authorization header to the request
  let jwtToken = JSON.parse(localStorage.getItem('AuthToken'));
  if (jwtToken) {
    config.headers['Authorization'] = `Bearer ${jwtToken}`;
  }
  let userId = JSON.parse(localStorage.getItem("School_id"));
  let schoolCode = localStorage.getItem("schoolCode");
  if (userId && schoolCode) {
    config.headers["X-User-ID"] = schoolCode + "_" + userId;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Response interceptor to handle token-related tasks for incoming responses
// instance.interceptors.response.use(
//   (response) => {
//     // Do something with the response data, if needed
//     return response;
//   },
//   (error) => {
//     // Handle unauthorized (401) or token expired errors
//     if (error.response && (error.response.status === 401 || error.response.status === 403)) {
//       // Redirect to login page, renew token, or handle as needed
//       console.error('Unauthorized request. Redirect to login page or renew token.');
//     }

//     return Promise.reject(error);
//   }
// );

export default instance;
